<div v-if="inline">
  <div class="card-body">
    <div v-if="selected_files.length" class="d-flex flex-wrap gap-3 mt-3 px-3">
      <div v-for="(item, index) in selected_files" :key="item.key" class="border rounded p-2 bg-light d-flex align-items-center gap-2">
        <i class="bi bi-file-earmark-text text-primary"></i>
        <span class="text-xxs">{{ item.name }}</span>
        <button type="button" class="btn btn-sm btn-danger text-xxs ms-2" @click="remove_selected_file(index)">
          Remove
        </button>
      </div>
    </div>

    <div>
      <div v-if="can_upload_documents">
        <div
          class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 mb-3 text-center transition-all position-relative"
          :class="is_dragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
          @dragover.prevent="on_drag_over"
          @dragenter.prevent="on_drag_over"
          @dragleave.prevent="on_drag_leave"
          @drop.prevent="on_drop"
          @click="trigger_file_picker"
        >
          <div class="d-flex align-items-center justify-content-center gap-2 h-100">
            <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
            <span class="fw-bold text-black text-sm">Drag & Drop documents here or click</span>
          </div>
          <input
            ref="documentFilesInput"
            class="d-none"
            type="file"
            multiple
            :accept="accepted_types"
            @change="on_files_selected"
          />
        </div>

        <div v-if="file_error" class="text-danger text-xxs mb-2">{{ file_error }}</div>

        <div class="d-flex flex-wrap gap-2 ms-auto justify-content-end align-items-center">
          <div class="form-check form-switch form-switch-xs m-0 me-1 ps-4 d-flex align-items-center gap-1">
            <input
              id="inline_public_slides"
              v-model="public_slides"
              class="form-check-input mt-0 me-1"
              type="checkbox"
              :disabled="is_saving_visibility"
              @change="save_slides_visibility"
            />
            <label for="inline_public_slides" class="form-check-label text-xxs fw-500 mb-0">
              Public materials
            </label>
          </div>
          <button
            v-if="selected_files.length"
            type="button"
            class="btn btn-sm btn-danger text-xxs"
            @click="clear_selected_files"
          >
            Clear
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary text-xxs"
            :disabled="!selected_files.length || is_uploading"
            @click="upload_documents"
          >
            <span v-if="is_uploading" class="spinner-border spinner-border-sm me-2"></span>
            Upload
          </button>
        </div>
      </div>

      <div v-if="is_loading" class="text-center py-5 w-100">
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 mb-0 text-muted text-xxs">Loading documents...</p>
      </div>

      <div v-else class="row g-3 mt-3">
       <div class="row">
          <div
            v-for="item in documents"
            :key="item.id"
            class="col-12 col-sm-12 col-lg-6 mb-3"
          >
            <div
              class="border rounded p-2 p-md-3 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2"
            >
              <!-- LEFT SECTION -->
              <div class="d-flex align-items-center gap-2 w-100">
                <img
                  :src="get_icon_class(item)"
                  class="file-icon flex-shrink-0"
                />

                <div class="d-flex flex-column overflow-hidden">
                  <span class="text-xxs fw-500 text-truncate">
                    {{ get_file_name(item) }}
                  </span>
                  <small class="text-muted text-xxs">
                    {{ get_file_type_label(item) }}
                  </small>
                </div>
              </div>

              <!-- RIGHT SECTION -->
              <div
                class="d-flex flex-wrap flex-md-nowrap align-items-center gap-1 gap-md-2 w-100 w-md-auto justify-content-end"
              >
                <button
                  class="btn btn-sm text-xxs cursor-pointer"
                  type="button"
                  @click="open_preview(item)"
                >
                <i class="bi bi-eye"></i>
                </button>

                <button
                  class="btn btn-sm text-xxs cursor-pointer"
                  type="button"
                  @click="download_document(item)"
                >
                <i class="bi bi-download"></i>
                </button>

                <button
                  v-if="can_upload_documents"
                  class="btn btn-sm text-xxs cursor-pointer text-danger"
                  type="button"
                  @click="delete_document(item)"
                >
                <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!documents.length" class="text-center text-muted py-5 text-xxs">
          No documents uploaded yet.
        </div>
      </div>
    </div>
  </div>
</div>

<teleport v-else to="body">
  <div class="modal fade" id="event_document_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-xxs fw-500 text-white">Event Documents</h5>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="reset"
          ></button>
        </div>

        <div v-if="selected_files.length" class="d-flex flex-wrap gap-3 mt-3 px-3">
          <div v-for="(item, index) in selected_files" :key="item.key" class="border rounded p-2 bg-light d-flex align-items-center gap-2">
            <i class="bi bi-file-earmark-text text-primary"></i>
            <span class="text-xxs">{{ item.name }}</span>
            <button type="button" class="btn btn-sm btn-danger text-xxs ms-2" @click="remove_selected_file(index)">
              Remove
            </button>
          </div>
        </div>

        <div class="modal-body">
          <div v-if="can_upload_documents">
            <div
              class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 mb-3 text-center transition-all position-relative"
              :class="is_dragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
              @dragover.prevent="on_drag_over"
              @dragenter.prevent="on_drag_over"
              @dragleave.prevent="on_drag_leave"
              @drop.prevent="on_drop"
              @click="trigger_file_picker"
            >
              <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                <span class="fw-bold text-black text-sm">Drag & Drop documents here or click</span>
              </div>
              <input
                ref="documentFilesInput"
                class="d-none"
                type="file"
                multiple
                :accept="accepted_types"
                @change="on_files_selected"
              />
            </div>

            <div v-if="file_error" class="text-danger text-xxs mb-2">{{ file_error }}</div>

            <div class="d-flex gap-2 ms-auto justify-content-end">
              <button
                v-if="selected_files.length"
                type="button"
                class="btn btn-sm btn-danger text-xxs"
                @click="clear_selected_files"
              >
                Clear
              </button>
              <button
                type="button"
                class="btn btn-sm btn-primary text-xxs"
                :disabled="!selected_files.length || is_uploading"
                @click="upload_documents"
              >
                <span v-if="is_uploading" class="spinner-border spinner-border-sm me-2"></span>
                Upload
              </button>
            </div>
          </div>

          <div v-if="is_loading" class="text-center py-5 w-100">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 mb-0 text-muted text-xxs">Loading documents...</p>
          </div>

          <div v-else class="row g-3 mt-3">
           <div class="row">
              <div
                v-for="item in documents"
                :key="item.id"
                class="col-12 col-sm-12 col-lg-6 mb-3"
              >
                <div
                  class="border rounded p-2 p-md-3 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2"
                >
                  <!-- LEFT SECTION -->
                  <div class="d-flex align-items-center gap-2 w-100">
                    <img
                      :src="get_icon_class(item)"
                      class="file-icon flex-shrink-0"
                    />

                    <div class="d-flex flex-column overflow-hidden">
                      <span class="text-xxs fw-500 text-truncate">
                        {{ get_file_name(item) }}
                      </span>
                      <small class="text-muted text-xxs">
                        {{ get_file_type_label(item) }}
                      </small>
                    </div>
                  </div>

                  <!-- RIGHT SECTION -->
                  <div
                    class="d-flex flex-wrap flex-md-nowrap align-items-center gap-1 gap-md-2 w-100 w-md-auto justify-content-end"
                  >
                    <button
                      class="btn btn-sm btn-outline-primary text-xxs flex-fill flex-md-grow-0"
                      @click="open_preview(item)"
                    >
                      View
                    </button>

                    <button
                      class="btn btn-sm btn-outline-secondary text-xxs flex-fill flex-md-grow-0"
                      @click="download_document(item)"
                    >
                      Download
                    </button>

                    <button
                      v-if="can_upload_documents"
                      class="btn btn-sm btn-danger text-xxs flex-fill flex-md-grow-0"
                      @click="delete_document(item)"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!documents.length" class="text-center text-muted py-5 text-xxs">
              No documents uploaded yet.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="event_document_preview_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-xxs fw-500 text-white">Preview</h5>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close_preview"
          ></button>
        </div>
        <div class="modal-body p-2">
          <iframe
            v-if="preview_type === 'pdf' || preview_type === 'word' || preview_type === 'excel' || preview_type === 'powerpoint'"
            :src="preview_url"
            width="100%"
            height="600px"
          ></iframe>
          <img v-else-if="preview_type === 'image'" :src="preview_url" class="w-100 rounded" />
          <p v-else class="text-center text-muted text-xxs mb-0">No preview available for this file type.</p>
        </div>
      </div>
    </div>
  </div>
</teleport>
